import React from 'react';

const MediaMeta = ({ mediaItem, editedMedia, editMode, isAdmin, handleInputChange }) => (
  <div className="meta-section">
    <h2>
      Meta Information
    </h2>
    <div className="info-section">
      <div className="info-details">
        <div className="info-item">
          <span className="info-label">
            <img src="/static/icons/clock-solid.svg" alt="Last Updated" className="field-icon icon" />
            Last Updated:
          </span>
          <span className="info-value">{new Date(mediaItem.last_updated).toLocaleString()}</span>
        </div>
        <div className="info-item">
          <span className="info-label">
            <img src="/static/icons/clock-solid.svg" alt="Last Activity" className="field-icon icon" />
            Last Activity:
          </span>
          <span className="info-value">{new Date(mediaItem.last_activity).toLocaleString()}</span>
        </div>
        <div className="info-item">
          <span className="info-label">
            <img src="/static/icons/star-solid.svg" alt="Favorite" className="field-icon icon" />
            Favorite:
          </span>
          <button
            className="favorite-btn"
            onClick={() => handleInputChange('is_favorite', !mediaItem.is_favorite)}
          >
            <img
              src={`/static/icons/${mediaItem.is_favorite ? 'star-solid.svg' : 'star-regular.svg'}`}
              alt="Favorite"
              className="field-icon icon"
            />
          </button>
        </div>
        {isAdmin && (
          <div className="info-item">
            <span className="info-label">
              <img src="/static/icons/triangle-exclamation-solid.svg" alt="Explicit" className="field-icon icon" />
              Explicit:
            </span>
            {editMode ? (
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={editedMedia.explicit || false}
                  onChange={(e) => handleInputChange('explicit', e.target.checked)}
                />
                <span className="slider"> 
                <span class="label-off">Safe</span>
                <span class="label-on">18+</span>
                </span>

              </label>
            ) : (
              <span className="info-value">{mediaItem.explicit ? '18+' : 'Safe'}</span>
            )}
          </div>
        )}

        {mediaItem.external_id && (
          <div className="info-item">
            <span className="info-label">
              <img src="/static/icons/link-solid.svg" alt="External ID" className="field-icon icon" />
              External ID:
            </span>
            {editMode && isAdmin ? (
              <input
                type="text"
                value={editedMedia.external_id || ''}
                onChange={(e) => handleInputChange('external_id', e.target.value)}
                className="info-input"
              />
            ) : (
              <span className="info-value">{mediaItem.external_id}</span>
            )}
          </div>
        )}
        <div className="info-item note-item">
          <span className="info-label">
            <img src="/static/icons/note-sticky-solid.svg" alt="Public Note" className="field-icon icon" />
            Public Note:
          </span>
          {editMode && isAdmin ? (
            <textarea
              value={editedMedia.public_note || ''}
              onChange={(e) => handleInputChange('public_note', e.target.value)}
              className="info-textarea"
            />
          ) : (
            <p className="info-value">{mediaItem.public_note || 'No public note.'}</p>
          )}
        </div>
        <div className="info-item note-item">
          <span className="info-label">
            <img src="/static/icons/lock-solid.svg" alt="Private Note" className="field-icon icon" />
            Private Note:
          </span>
          {editMode && isAdmin ? (
            <textarea
              value={editedMedia.private_note || ''}
              onChange={(e) => handleInputChange('private_note', e.target.value)}
              className="info-textarea"
            />
          ) : (
            <p className="info-value">{mediaItem.private_note || 'No private note.'}</p>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default MediaMeta;